import React from 'react';
import {connect} from 'react-redux';

import Advert from '../atoms/advert';

import * as TopSelectors from '../../selectors/topLevelSelectors';

export class AdsIframe extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Advert
        id="1"
        position={this.props.position}
        collapsed={1}
        country={this.props.country}
        isVisitorOnMobile={this.props.isVisitorOnMobile}
        responsiveSize={[
          [
            [0, 0],
            [this.props.width, this.props.height],
            [this.props.width, 1],
          ],
        ]}
        size={[
          [this.props.width, this.props.height],
          [this.props.width, 1],
        ]}
        reload={2}
      />
    );
  }
}

AdsIframe.defaultProps = {
  position: '',
  width: 300,
  height: 250,
};

/* =========== Below is for Redux State Connecting  =========== */
function mapStateToProps(state) {
  return {
    country: TopSelectors.user(state).country,
    isVisitorOnMobile: TopSelectors.ui(state).isMobileDevice,
    position: TopSelectors.page(state).position,
    height: TopSelectors.page(state).height,
    width: TopSelectors.page(state).width,
  };
}

export default connect(mapStateToProps)(AdsIframe);
